import { render, staticRenderFns } from "./OpenFastpay.vue?vue&type=template&id=c9124ea6"
import script from "./OpenFastpay.vue?vue&type=script&lang=js"
export * from "./OpenFastpay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports